export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13833.6f9e436d.jpg";